import { footerNav, siteMeta } from "@/mocks/home";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-tv-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading font-bold text-lg text-background-50">{siteMeta.name}</span>
            </div>
            <p className="mt-4 text-sm text-background-100/75 leading-relaxed max-w-sm">
              {siteMeta.name}官网入口与地址导航页，汇总可访问的网址与APP下载方式，
              帮助用户快速、安全地找到入口。
            </p>
            <p className="mt-4 text-xs text-background-100/55">
              最近更新：{siteMeta.updatedAt}
            </p>
          </div>

          <nav aria-label="页脚导航" className="md:col-span-1">
            <h2 className="font-heading font-bold text-sm text-background-50 mb-4">页面导航</h2>
            <ul className="grid grid-cols-2 gap-y-2.5 gap-x-4">
              {footerNav.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-100/75 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:col-span-1">
            <h2 className="font-heading font-bold text-sm text-background-50 mb-4">使用说明</h2>
            <ul className="space-y-3 text-sm text-background-100/75 leading-relaxed">
              <li className="flex gap-2">
                <i className="ri-information-line mt-0.5 shrink-0" aria-hidden="true" />
                本页仅提供访问与下载指引，不存储、不传播任何影视资源。
              </li>
              <li className="flex gap-2">
                <i className="ri-shield-check-line mt-0.5 shrink-0" aria-hidden="true" />
                请通过正规渠道使用服务，并遵守所在地相关法律法规。
              </li>
              <li className="flex gap-2">
                <i className="ri-link mt-0.5 shrink-0" aria-hidden="true" />
                线路信息会不定期核对更新，建议收藏本页以便随时查看。
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/60 text-center sm:text-left">
            © {year} {siteMeta.name} · 地址导航与访问指引页
          </p>
          <p className="text-xs text-background-100/60 text-center sm:text-right">
            内容以播出页面为准，本页仅供查询参考
          </p>
        </div>
      </div>
    </footer>
  );
}